var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":_vm.title,"transfer":_vm.transfer,"value":_vm.value,"width":_vm.width},on:{"input":_vm.inputHandler},scopedSlots:_vm._u([{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }